import { BASE_URL } from '@modules/articles/config/constants';
import type { ShouldRevalidateFunction } from 'react-router';

export const isArticlesPath = (pathname: string): boolean =>
    pathname === BASE_URL || pathname.startsWith(`${BASE_URL}/`);

/**
 * Layout loader (nav/common) is shared by articles index and category routes.
 * Skip revalidation when SPA navigation stays under `/articles` so RR7
 * single-fetch does not request layout data the response will not include.
 * Form submissions follow the same URL check so a redirect that leaves the
 * articles subtree still revalidates the layout.
 */
export const shouldRevalidateArticlesLayout: ShouldRevalidateFunction = ({
    currentUrl,
    nextUrl,
    defaultShouldRevalidate,
}) => {
    if (
        isArticlesPath(currentUrl.pathname) &&
        isArticlesPath(nextUrl.pathname)
    ) {
        return false;
    }
    return defaultShouldRevalidate;
};
